const { ExpressionBlock } = require('./expression-block');
const { assertTyped, normalize } = require('../core/value');
const { ExpressionFunction } = require('../core/expression-function');

class LiteralBlock extends ExpressionBlock {
  constructor(value, position = 0, length = 0) {
    super(position, length);
    this.value = assertTyped(value, 'LiteralBlock expects typed value');
  }

  evaluateInternal(provider) {
    const raw = this.value[1];
    if (raw instanceof ExpressionFunction) {
      const instance = raw.clone();
      instance.setContext(provider);
      return normalize(instance);
    }
    return this.value;
  }

  asExpressionString() {
    const val = this.value[1];
    if (val === null) {
      return 'null';
    }
    return String(val);
  }
}

module.exports = {
  LiteralBlock
};
